<template>
  <div class="page page-user-edit">
    <!--    <van-notice-bar color="#1989fa" background="#ecf9ff" wrapable :scrollable="false" left-icon="info-o">-->
    <!--      入职信息一经提交不可修改，请仔细填写。若不能确认部分信息可先使用保存功能！-->
    <!--    </van-notice-bar>-->
    <template v-if="userInfo">
      <van-cell-group class="app-card">
        <van-field class="readonly" label-align="left" v-model="userInfo.name" label="姓名" placeholder="未录入"
                   :readonly="true"/>
        <van-field class="readonly" v-model="userInfo.companyName" :readonly="true" label="派遣单位" placeholder="未录入"/>
        <van-field class="readonly" v-model="userInfo.paiqianEndDate" :readonly="true" label="离职日期" placeholder="未录入"/>
        <van-cell title="离职介绍信">
          <template slot="title">
          <span class="custom-title van-icon van-icon-question" style="color: #1989fa;"
                @click="showHelp('请拍照上传离职介绍信')">离职介绍信</span>
          </template>
          <upload v-model="userInfo.leaveIntroduction" :multiple="false" :params="uploadParams"></upload>
        </van-cell>
      </van-cell-group>
      <div style="margin-bottom: 60px;height: 1px;width: 100%;"></div>
      <div class="fixed-bottom"
           style="background: #fff;display: flex;flex-direction: row;flex-wrap: nowrap; justify-content: space-around;">
        <van-button style="width: 40%;" type="info" round
                    @click="handleClickSubmit(false)">确认并提交
        </van-button>
      </div>
      <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
    </template>
  </div>
</template>

<style>
.label-offset .van-field__label {
  width: 95px;
}

.van-icon-question::before {
  color: #999;
  font-size: 16px;
}

.van-field__left-icon {
  margin-right: 0;
}

.van-field__control {
  color: #000000;
}

.van-field__label {
  color: #1989fa;
}

.van-field__label {
  width: 110px;
}

/* 	.readonly input {
		color: #999;
	} */
.readonly .van-cell__title,
.readonly .van-field__control {
  color: #999;
}

.van-field__label {
  text-align: left;
}

.ck-wrapper .van-field__label {
  width: 210px;
}

.van-uploader__preview,
.van-uploader__upload {
  margin-top: 8px;
}

.van-uploader__preview-image {
  border: 1px solid #eee;
}
</style>

<script>
import BindPersonnel from '@/components/BindPersonnel';
import mixinLoad from '@/mixin/mixin-load.js';
import {NumberKeyboard} from 'vant';
import Upload from '@/components/Upload';
import nativeApi from '@/utils/native-bridge.js';
import {getDeleteDetail, submitDeleteDetail} from '@/api/user-info.js';

const fullYear = new Date().getFullYear();
const oneMonthTime = 24 * 3600 * 1000 * 31;

const minWorkDate = new Date();
minWorkDate.setFullYear(fullYear - 70);

const maxWorkDate = new Date();
maxWorkDate.setTime(maxWorkDate.getTime() + (oneMonthTime * 3));

const birthDayMin = new Date();
birthDayMin.setFullYear(fullYear - 70);

const birthDayMax = new Date();
birthDayMax.setFullYear(fullYear - 17);

const minPreWorkDate = new Date();
minPreWorkDate.setFullYear(minPreWorkDate.getFullYear() - 10);

const maxPreWorkDate = new Date();
maxPreWorkDate.setTime(maxPreWorkDate.getTime() + oneMonthTime);

const minIdCardDate = new Date();
minIdCardDate.setFullYear(2004);
minIdCardDate.setMonth(0);
minIdCardDate.setDate(1);

export default {
  name: 'UserInfoDelete',
  components: {
    Upload,
    BindPersonnel,
    [NumberKeyboard.name]: NumberKeyboard
  },
  mixins: [mixinLoad],
  data() {
    return {
      uploadParams: {
        fileType: 'img',
        subType: 'png,jpeg,jpg',
        fileMaxSize: '10240',
        checkFile: '0',
        serverCheck: '1',
        secrecyLevel: '1'
      },
      helpTip: null,
      fileList: [],
      userInfo: null,
    };
  },
  watch: {},
  computed: {
    weirenClientInfo() {
      return nativeApi.getWeirenClientInfo();
    }
  },
  methods: {
    showHelp(msg) {
      this.$dialog.alert({
        message: msg
      });
    },
    handlePickFile() {
      const _this = this;
      nativeApi.pickFile({
        fileMaxSize: 500,
        success: data => {
          _this.$nextTick(() => {
            _this.userInfo.certImgUrl = data.replace(/\\/g, '');
          });
          _this.showTip('上传成功');
        },
        cancel: () => {
          _this.showTip('已取消');
        },
        error: rep => {
          _this.showErrorTip(rep.msg);
        }
      });
    },
    handleClickSubmit() {
      this.$dialog
          .confirm({
            title: '确认并提交',
            message: '是否提交信息',
            confirmButtonText: '确定',
            cancelButtonText: '再想想'
          })
          .then(() => {
            const loading = this.showLoading();
            submitDeleteDetail(this.userInfo)
                .then(rep => {
                  loading.clear();
                  this.showSuccessTip(rep.msg);
                  this.loadData();
                })
                .catch(() => {
                  loading.clear();
                });
          });
    },
    loadData() {
      const loading = this.showLoading();
      getDeleteDetail({id: this.$route.query.id})
          .then(rep => {
            loading.clear();
            this.userInfo = rep.data;
          })
          .catch(() => {
            loading.clear();
          });
    }
  },
  created() {
    this.loadData();
  }
};
</script>
